import * as React from "react";
import { EnvironmentColor } from "environments/components/EnvironmentColorSelector";
import useUserTheme from "shared/styles/hooks/useUserTheme";
import { Utilities } from "shared/utilities";
import { useLocation, useRouteMatch } from "react-router-dom";
import { IPathParams } from "navigation/App";
import { defaultEnvironmentName } from "shared/model/AgentGroup";

const useNavbarColor = (props: IUseNavbarColorProps) => {
    const match = useRouteMatch<IPathParams>(props.route);
    const location = useLocation();
    const environmentName = match?.params.environmentName ?? defaultEnvironmentName;

    const [themeType] = useUserTheme();
    const [navbarColorVariant, setNavbarColorVariant] = React.useState<EnvironmentColor>("default");
    const [hasFetched, setHasFetched] = React.useState<boolean>(false);

    React.useEffect(() => {
        const fetchEnvironmentColor = async () => {
            const colorVariantResponse = await Utilities.getFetchWithoutResultParsing(`api/environment/${environmentName}/color`);

            if (!colorVariantResponse.ok) {
                setNavbarColorVariant("default");
                setHasFetched(true);
                return;
            }

            const colorVariant = await colorVariantResponse.text() as EnvironmentColor;

            setNavbarColorVariant(colorVariant);
            setHasFetched(true);
        }
        if (props.route) {
            fetchEnvironmentColor();
        }
    }, [props.route, themeType, location]);


    return { hasFetched, navbarColorVariant }

}

interface IUseNavbarColorProps {
    route: string;
}

export default useNavbarColor;